import React, { useState } from "react";
import "./Contact.css";
import API from "../api/Api";

const SendMessageFormBootstrap = () => {

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    userType: "",
    category: "",
    subject: "",
    message: ""
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    let value = e.target.value;

    if (e.target.name === "phone") {
      value = value.replace(/\D/g, "");
    }

    setForm({ ...form, [e.target.name]: value });
  };

  const validate = () => {
    let err = {};

    if (!form.name.trim()) {
      err.name = "Full name is required";
    } else if (!/^[A-Za-z\s]+$/.test(form.name)) {
      err.name = "Only letters allowed";
    }

    if (!form.email) {
      err.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      err.email = "Invalid email format";
    }

    if (!form.phone) {
      err.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(form.phone)) {
      err.phone = "Phone must be exactly 10 digits";
    }

    if (!form.userType) err.userType = "Select user type";
    if (!form.category) err.category = "Select category";
    if (!form.subject.trim()) err.subject = "Subject is required";

    if (!form.message.trim()) {
      err.message = "Message is required";
    } else if (form.message.length < 20) {
      err.message = "Minimum 20 characters required";
    }

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      const response = await API.post("/contact-us", form);

      alert(response.data.message || "Message sent successfully");

      setForm({
        name: "",
        email: "",
        phone: "",
        userType: "",
        category: "",
        subject: "",
        message: ""
      });

      setErrors({});

    } catch (error) {
      console.error("Error:", error);
      alert(error.response?.data?.message || "Server error");
    }
  };

  return (
    <section className="touch-bs-section py-5">
      <div className="container">
        <div className="row g-4 align-items-stretch">

          {/* LEFT SIDE */}
          <div className="col-lg-5">
            <div className="touch-bs-left h-100">
              <span className="touch-bs-badge">GET IN TOUCH</span>

              <h2 className="touch-bs-title">
                Get in touch <br /> with us
              </h2>

              <p className="touch-bs-text">
                Have questions, feedback, or need support regarding the CSR Portal?
                Fill out the form and our team will respond within
                <strong> 2–3 business days</strong>.
              </p>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="col-lg-7">
            <div className="touch-bs-form card shadow-sm h-100">
              <div className="card-body p-4">
                <h5 className="mb-3 fw-bold">Send Us a Message</h5>

                <form onSubmit={handleSubmit}>
                  <div className="row g-3">

                    {/* NAME */}
                    <div className="col-md-6">
                     <label className="form-label">
  Full Name <span className="required-star">*</span>
</label>
                      <input
                        type="text"
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                        className={`form-control ${errors.name ? "is-invalid" : ""}`}
                      />
                      {errors.name && <small className="text-danger">{errors.name}</small>}
                    </div>

                    {/* EMAIL */}
                    <div className="col-md-6">
                    <label className="form-label">
  Email Address <span className="required-star">*</span>
</label>
                      <input
                        type="text"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        className={`form-control ${errors.email ? "is-invalid" : ""}`}
                      />
                      {errors.email && <small className="text-danger">{errors.email}</small>}
                    </div>

                    {/* PHONE */}
                    <div className="col-md-6">
                     <label className="form-label">
  Phone Number <span className="required-star">*</span>
</label>
                      <input
                        type="text"
                        name="phone"
                        value={form.phone}
                        onChange={handleChange}
                        className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                      />
                      {errors.phone && <small className="text-danger">{errors.phone}</small>}
                    </div>

                    {/* USER TYPE */}
                    <div className="col-md-6">
                     <label className="form-label">
  User Type <span className="required-star">*</span>
</label>
                      <select
                        name="userType"
                        value={form.userType}
                        onChange={handleChange}
                        className={`form-select ${errors.userType ? "is-invalid" : ""}`}
                      >
                        <option value="">Select user type</option>
                        <option value="Corporate">Corporate</option>
                        <option value="NGO">NGO</option>
                        <option value="Government">Government</option>
                        <option value="Citizen">Citizen</option>
                      </select>
                      {errors.userType && <small className="text-danger">{errors.userType}</small>}
                    </div>

                    {/* CATEGORY */}
                    <div className="col-12">
                     <label className="form-label">
  Department / Support Category <span className="required-star">*</span>
</label>
                      <select
                        name="category"
                        value={form.category}
                        onChange={handleChange}
                        className={`form-select ${errors.category ? "is-invalid" : ""}`}
                      >
                        <option value="">Select category</option>
                        <option value="Technical Support">Technical Support</option>
                        <option value="Project Related">Project Related</option>
                        <option value="Compliance">Compliance</option>
                        <option value="Other">Other</option>
                      </select>
                      {errors.category && <small className="text-danger">{errors.category}</small>}
                    </div>

                    {/* SUBJECT */}
                    <div className="col-12">
                    <label className="form-label">
  Subject <span className="required-star">*</span>
</label>
                      <input
                        type="text"
                        name="subject"
                        value={form.subject}
                        onChange={handleChange}
                        className={`form-control ${errors.subject ? "is-invalid" : ""}`}
                      />
                      {errors.subject && <small className="text-danger">{errors.subject}</small>}
                    </div>

                    {/* MESSAGE */}
                    <div className="col-12">
                     <label className="form-label">
  Message <span className="required-star">*</span>
</label>
                      <textarea
                        name="message"
                        value={form.message}
                        onChange={handleChange}
                        className={`form-control ${errors.message ? "is-invalid" : ""}`}
                      ></textarea>
                      {errors.message && <small className="text-danger">{errors.message}</small>}
                    </div>

                    {/* BUTTON */}
                    <div className="col-12 mt-3">
                      <button type="submit" className="btn btn-primary px-4">
                        Submit Message
                      </button>
                    </div>

                  </div>
                </form>

              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default SendMessageFormBootstrap;